import axios from 'axios'

import config from '../../config'

const updateNotificationGroup = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/NotificationGroups`
  return axios.put(url, data)
}

export default updateNotificationGroup
